import referralImage from "assets/images/referrals/referral-invite-signup.png";
import "./index.scss";

export const ReferralSignupSection = () => {
  return (
    <section
      className="referral-section-container"
      data-testid="referral-section"
    >
      <div className="referral-text">
        <h3 className="referral-subtitle">TWO WAYS TO SAVE</h3>
        <h2 className="referral-title">
          Buy gift cards for yourself and save every day.
        </h2>
        <h4 className="referral-title-minor">DISCOUNT</h4>
        <p className="referral-description">
          Buy discounted gift cards and save up to 30% at thousands of your
          favorite stores.
        </p>
        <h4 className="referral-title-minor">GCX Cash</h4>
        <p className="referral-description">
          Buy gift cards at face value and get up to 10% back in GCX Cash to
          spend on future purchases.
        </p>
      </div>
      <img
        src={referralImage}
        alt="Referral invite"
        className="referral-image-invite"
      />
    </section>
  );
};
